<div class="container">
  <div class="content">
    <h1>{{ 'general.unauthorized-headline' | translate }}</h1>
    <h4></h4>
    <h4>{{ 'general.unauthorized-sub-headline' | translate }}</h4>
  </div>
</div>
